import { render } from "./CrmSegmentsForm.vue?vue&type=template&id=38cc8abc&scoped=true"
const script = {}

import "./CrmSegmentsForm.vue?vue&type=style&index=0&id=38cc8abc&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38cc8abc"]])

export default __exports__